<div class="container-fluid">
    <div class="row mb-3">
        <div class="col-12 d-flex justify-content-between align-items-center">
            <h3>Ad Banners</h3>
            <button class="btn btn-success" (click)="navigateAdd()">
                <i class="fa fa-plus me-2"></i>Add Ad Banner
            </button>
        </div>
    </div>

    <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

    <div *ngIf="!loading && banners.length === 0" class="text-center py-5">
        <i class="fa fa-image fa-4x text-muted mb-3"></i>
        <p class="text-muted">No ad banners found. Click "Add Ad Banner" to create one.</p>
    </div>

    <div *ngIf="!loading && banners.length > 0">
        <div class="card" *ngFor="let banner of banners | paginate: config">
            <div class="card-body d-flex align-items-center gap-3">
                <img [src]="imageUrl(banner.imagePath)" alt="Banner"
                     style="width: 120px; height: 60px; object-fit: cover; border-radius: 6px; background: #f0f0f0;">
                <div class="flex-grow-1">
                    <div class="mb-1">
                        <span class="badge bg-primary me-2">{{ groupLabel(banner.bannerGroup) }}</span>
                        <span class="text-muted">Position: {{ banner.position }}</span>
                        <span [class]="banner.active ? 'badge bg-success ms-2' : 'badge bg-secondary ms-2'">
                            {{ banner.active ? 'Active' : 'Inactive' }}
                        </span>
                    </div>
                    <small class="text-muted" *ngIf="banner.url">URL: {{ banner.url }}</small>
                </div>
                <div class="d-flex gap-2">
                    <button class="btn btn-sm btn-outline-primary" (click)="navigateEdit(banner.id)">
                        <i class="fa fa-edit"></i> Edit
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="deleteBanner(banner)">
                        <i class="fa fa-trash"></i> Delete
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-3" *ngIf="!loading && config?.totalOfPage > 1">
        <div class="col-12">
            <pagination-controls id="adBanners" maxSize="5" previousLabel="Previous" nextLabel="Next"
                (pageChange)="pageChange($event)" autoHide="true">
            </pagination-controls>
        </div>
    </div>
</div>
